// extracted by mini-css-extract-plugin
module.exports = {"form":"form__3byml","body":"body__2-8Ik","select":"select__20GuH","groupSelect":"groupSelect__paTMO","removeButton":"removeButton__1akFW"};